export enum SelectableFilterSize {
  small = 's',
  medium = 'm',
}

export enum SelectableFilterState {
  selected = 'selected',
  unselected = 'unselected',
}

export interface SelectableFilterProps {
  className?: string
  imgAlt?: string
  imgSrc?: string
  onClick?: (event: React.MouseEvent<HTMLDivElement>) => void
  isSelected?: boolean
  size?: SelectableFilterSize
  title: string
}
